module.exports = __webpack_public_path__ + "an.no1.51d2d4c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/an.no1.jpg
// module id = 13h7
// module chunks = 0